// @flow
import * as React from 'react';
import Error500 from '../Error500/container';
import ErrorNotFound from '../ErrorNotFound/container';

type Props = {
  statusCode: number,
  routeName: ?string,
};

function Error({ statusCode, routeName }: Props): React.Node {
  return (
    <div>
      {statusCode === 500 ? (
        <Error500 />
      ) : (
        <ErrorNotFound statusCode={statusCode} routeName={routeName} />
      )}
    </div>
  );
}

export default Error;



// WEBPACK FOOTER //
// ./app/Error/components/Error/index.js